import * as React from 'react'
import styled from 'styled-components'
import Icon from '../Icons/Icon'

interface IProps {
	onClick: () => void
}

const Container = styled.a`
	color: #6b778c;
	fill: #6b778c;
	padding: 10px 8px 10px 12px;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
	cursor: pointer;

	svg, i {
		color: #6b778c;
		fill: #6b778c;
	}

	&:hover {
		svg, i {
			color: #172b4d;
			fill: #172b4d;
		}
	}
`

const TaskPopoverBack = (props: IProps) => {
	return (
		<Container onClick={props.onClick}>
			<Icon icon='chevron-left' />
		</Container>
	)
}

export default TaskPopoverBack